var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !!_vm.widget.widgetList && _vm.widget.widgetList.length > 0
        ? [
            _vm._l(_vm.widget.widgetList, function (subWidget, swIdx) {
              return [
                "container" === subWidget.category
                  ? [
                      _c(_vm.getComponentByContainer(subWidget), {
                        key: swIdx,
                        tag: "component",
                        attrs: {
                          widget: subWidget,
                          "parent-list": _vm.widget.widgetList,
                          "index-of-parent-list": swIdx,
                          "parent-widget": _vm.widget,
                          "sub-form-row-id": _vm.subFormRowId,
                          "sub-form-row-index": _vm.subFormRowIndex,
                          "sub-form-col-index": _vm.subFormColIndex,
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm._l(Object.keys(_vm.$slots), function (slot) {
                              return {
                                key: slot,
                                fn: function (scope) {
                                  return [_vm._t(slot, null, null, scope)]
                                },
                              }
                            }),
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  : [
                      _c(subWidget.type + "-widget", {
                        key: swIdx,
                        tag: "component",
                        attrs: {
                          field: subWidget,
                          designer: null,
                          "parent-list": _vm.widget.widgetList,
                          "index-of-parent-list": swIdx,
                          "parent-widget": _vm.widget,
                          "sub-form-row-id": _vm.subFormRowId,
                          "sub-form-row-index": _vm.subFormRowIndex,
                          "sub-form-col-index": _vm.subFormColIndex,
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm._l(Object.keys(_vm.$slots), function (slot) {
                              return {
                                key: slot,
                                fn: function (scope) {
                                  return [_vm._t(slot, null, null, scope)]
                                },
                              }
                            }),
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
              ]
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }